module.exports = __webpack_public_path__ + "static/media/HCMM745.6b2cb121.jpg";